import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Event from '../Event/Event';
import Flexpass from '../Flexpass/Flexpass';
import { SetComponentLanguage } from '../../../helpers';
import LocalizedStrings from 'react-localization';
import InfiniteScroll from 'react-infinite-scroll-component';
import moment from 'moment';
import en from './locales/en.json';
import fr from './locales/fr.json';
import './EventCategory.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class EventCategory extends Component {

    renderFlexpasses = (flexpass, i, status) => {
        let localUTC = moment().utc();
        if(status === 'active'){
            // If box office, check for box office sale end date
            if(this.props.user.role === 'box-office' || this.props.user.role === 'client'){
                //if(localUTC.isBefore(flexpass.sale_end_box_office)){
                    return (
                        <Flexpass
                            key={"flexpass_" + status + "_" + i}
                            flexpass={flexpass}
                            status={status}
                            user={this.props.user}
                            is_client={this.props.is_client}
                            current_client_id={this.props.current_client_id}
                            toggleAllCategories={this.props.toggleAllCategories}
                            toggleDetails={this.props.toggleDetails}
                            toggleDate={this.props.toggleDate}
                            toggleAllDates={this.props.toggleAllDates}
                            toggleDateSettings={this.props.toggleDateSettings}
                            closeAllOpenDateSettings={this.props.closeAllOpenDateSettings}
                            populateTicketSelection={this.props.populateTicketSelection}
                            toggleConfirmDeleteEvent={this.props.toggleConfirmDeleteEvent}
                            toggleConfirmEarlyPayout={this.props.toggleConfirmEarlyPayout}
                            handlePrinterChange={this.props.handlePrinterChange}
                            currentPrinter={this.props.currentPrinter}
                            printers={this.props.printers}
                            getAccountEventReport={this.props.getAccountEventReport}
                            getStreamAccessReport={this.props.getStreamAccessReport}
                            getTicketPriceSummary={this.props.getTicketPriceSummary}
                            getTicketBreakdown={this.props.getTicketBreakdown}
                            getSeatingReport={this.props.getSeatingReport}
                            getHouseCount={this.props.getHouseCount}
                            togglePassword={this.props.togglePassword}
                            toggleConfirmDeleteFlexpass={this.props.toggleConfirmDeleteFlexpass}
                        />
                    )
                //}
            } else {
                let localUTC = moment().utc();
                if(!localUTC.isBetween(flexpass.sale_start, flexpass.sale_end) && flexpass.presale_password === '') {
                    return null;
                } else {
                    return (
                        <Flexpass
                            key={"flexpass_active_"+i}
                            flexpass={flexpass}
                            status={status}
                            user={this.props.user}
                            is_client={this.props.is_client}
                            current_client_id={this.props.current_client_id}
                            toggleAllCategories={this.props.toggleAllCategories}
                            toggleDetails={this.props.toggleDetails}
                            toggleDate={this.props.toggleDate}
                            toggleAllDates={this.props.toggleAllDates}
                            toggleDateSettings={this.props.toggleDateSettings}
                            closeAllOpenDateSettings={this.props.closeAllOpenDateSettings}
                            populateTicketSelection={this.props.populateTicketSelection}
                            toggleConfirmDeleteEvent={this.props.toggleConfirmDeleteEvent}
                            toggleConfirmEarlyPayout={this.props.toggleConfirmEarlyPayout}
                            handlePrinterChange={this.props.handlePrinterChange}
                            currentPrinter={this.props.currentPrinter}
                            printers={this.props.printers}
                            getAccountEventReport={this.props.getAccountEventReport}
                            getStreamAccessReport={this.props.getStreamAccessReport}
                            getTicketPriceSummary={this.props.getTicketPriceSummary}
                            getTicketBreakdown={this.props.getTicketBreakdown}
                            getSeatingReport={this.props.getSeatingReport}
                            getHouseCount={this.props.getHouseCount}
                            togglePassword={this.props.togglePassword}
                            toggleConfirmDeleteFlexpass={this.props.toggleConfirmDeleteFlexpass}
                        />
                    )
                }
            }

            // If Flexpass has all presale options
            if(flexpass.presale_start && flexpass.presale_end && flexpass.presale_password !== ""){
                if(this.props.user.role !== 'box-office' && this.props.user.role !== 'client'){
                    if(localUTC.isBetween(flexpass.presale_start, flexpass.presale_end)){
                        return (
                            <Flexpass
                                key={"flexpass_active_"+i}
                                flexpass={flexpass}
                                status={status}
                                user={this.props.user}
                                is_client={this.props.is_client}
                                current_client_id={this.props.current_client_id}
                                toggleAllCategories={this.props.toggleAllCategories}
                                toggleDetails={this.props.toggleDetails}
                                toggleDate={this.props.toggleDate}
                                toggleAllDates={this.props.toggleAllDates}
                                toggleDateSettings={this.props.toggleDateSettings}
                                closeAllOpenDateSettings={this.props.closeAllOpenDateSettings}
                                populateTicketSelection={this.props.populateTicketSelection}
                                toggleConfirmDeleteEvent={this.props.toggleConfirmDeleteEvent}
                                toggleConfirmEarlyPayout={this.props.toggleConfirmEarlyPayout}
                                handlePrinterChange={this.props.handlePrinterChange}
                                currentPrinter={this.props.currentPrinter}
                                printers={this.props.printers}
                                getAccountEventReport={this.props.getAccountEventReport}
                                getStreamAccessReport={this.props.getStreamAccessReport}
                                getTicketPriceSummary={this.props.getTicketPriceSummary}
                                getTicketBreakdown={this.props.getTicketBreakdown}
                                getSeatingReport={this.props.getSeatingReport}
                                getHouseCount={this.props.getHouseCount}
                                togglePassword={this.props.togglePassword}
                                toggleConfirmDeleteFlexpass={this.props.toggleConfirmDeleteFlexpass}
                            />
                        )
                    }
                }
            }
        }

        if(status === 'past'){
            // If box office, check for box office sale end date
            if(this.props.user.role === 'box-office' || this.props.user.role === 'client'){
                if(localUTC.isAfter(flexpass.sale_end_box_office) && localUTC.isAfter(flexpass.sale_end)){
                    return (
                        <Flexpass
                            key={"flexpass_" + status + "_" + i}
                            flexpass={flexpass}
                            status={status}
                            user={this.props.user}
                            is_client={this.props.is_client}
                            current_client_id={this.props.current_client_id}
                            toggleAllCategories={this.props.toggleAllCategories}
                            toggleDetails={this.props.toggleDetails}
                            toggleDate={this.props.toggleDate}
                            toggleAllDates={this.props.toggleAllDates}
                            toggleDateSettings={this.props.toggleDateSettings}
                            closeAllOpenDateSettings={this.props.closeAllOpenDateSettings}
                            populateTicketSelection={this.props.populateTicketSelection}
                            toggleConfirmDeleteEvent={this.props.toggleConfirmDeleteEvent}
                            toggleConfirmEarlyPayout={this.props.toggleConfirmEarlyPayout}
                            handlePrinterChange={this.props.handlePrinterChange}
                            currentPrinter={this.props.currentPrinter}
                            printers={this.props.printers}
                            getAccountEventReport={this.props.getAccountEventReport}
                            getTicketPriceSummary={this.props.getTicketPriceSummary}
                            getTicketBreakdown={this.props.getTicketBreakdown}
                            getSeatingReport={this.props.getSeatingReport}
                            getHouseCount={this.props.getHouseCount}
                            togglePassword={this.props.togglePassword}
                            toggleConfirmDeleteFlexpass={this.props.toggleConfirmDeleteFlexpass}
                        />
                    )
                }
            } else {
                if(localUTC.isAfter(flexpass.sale_end)){
                    return (
                        <Flexpass
                            key={"flexpass_active_"+i}
                            flexpass={flexpass}
                            status={status}
                            user={this.props.user}
                            is_client={this.props.is_client}
                            current_client_id={this.props.current_client_id}
                            toggleAllCategories={this.props.toggleAllCategories}
                            toggleDetails={this.props.toggleDetails}
                            toggleDate={this.props.toggleDate}
                            toggleAllDates={this.props.toggleAllDates}
                            toggleDateSettings={this.props.toggleDateSettings}
                            closeAllOpenDateSettings={this.props.closeAllOpenDateSettings}
                            populateTicketSelection={this.props.populateTicketSelection}
                            toggleConfirmDeleteEvent={this.props.toggleConfirmDeleteEvent}
                            toggleConfirmEarlyPayout={this.props.toggleConfirmEarlyPayout}
                            handlePrinterChange={this.props.handlePrinterChange}
                            currentPrinter={this.props.currentPrinter}
                            printers={this.props.printers}
                            getAccountEventReport={this.props.getAccountEventReport}
                            getTicketPriceSummary={this.props.getTicketPriceSummary}
                            getTicketBreakdown={this.props.getTicketBreakdown}
                            getSeatingReport={this.props.getSeatingReport}
                            getHouseCount={this.props.getHouseCount}
                            togglePassword={this.props.togglePassword}
                            toggleConfirmDeleteFlexpass={this.props.toggleConfirmDeleteFlexpass}
                        />
                    )
                }
            }
        }
    }

    renderUserCategory = () => {
        if (this.props.is_client) {
            switch (this.props.category.name) {
                case 'active':
                    return <button
                        className={"showtix-category__button showtix-category__button__published" + (this.props.isCategoryOpen.active ? ' is-active' : '')}
                        onClick={() => this.props.toggleCategory(this.props.category.name)}
                        aria-expanded={this.props.isCategoryOpen.active}
                        aria-controls='category-active'
                    >{strings.publishedEvents} <i></i></button>;

                case 'pending':
                    return <button
                        className={"showtix-category__button showtix-category__button__unpublished" + (this.props.isCategoryOpen.pending ? ' is-active' : '')}
                        onClick={() => this.props.toggleCategory(this.props.category.name)}
                        aria-expanded={this.props.isCategoryOpen.pending}
                        aria-controls='category-pending'
                    >{strings.unpublishedEvents} <i></i></button>;

                case 'past':
                    return <button
                        className={"showtix-category__button showtix-category__button__past" + (this.props.isCategoryOpen.past ? ' is-active' : '')}
                        onClick={() => this.props.toggleCategory(this.props.category.name)}
                        aria-expanded={this.props.isCategoryOpen.past}
                        aria-controls='category-past'
                    >{strings.pastEvents} <i></i></button>;

                default:
                    return <button
                        className={"showtix-category__button showtix-category__button__published" + (this.props.isCategoryOpen.active ? ' is-active' : '')}
                        onClick={() => this.props.toggleCategory(this.props.category.name)}
                        aria-expanded={this.props.isCategoryOpen.active}
                        aria-controls='category-active'
                    >{strings.publishedEvents} <i></i></button>;
            } 
        }    
        else {
            if (!this.props.isConfirmationOpen) {
                return <button
                    className={"showtix-category__button showtix-category__button__published" + (this.props.isCategoryOpen.active ? ' is-active' : '')}
                    onClick={() => this.props.toggleCategory(this.props.category.name)}
                    aria-expanded={this.props.isCategoryOpen.active}
                    aria-controls='category-active'
                >{strings.currentEvents} <i></i></button>;
            }
        }
    }

    fetchData = () => {
        this.props.updateCategoryEvents('past');
    };

    render() {
        return (
            <div className="showtix-category">
                {this.renderUserCategory()}
                {/* If client or box office, all PUBLISHED events should be displayed, no matter the presale start or public sale start */}
                {(this.props.user.role === 'client' || this.props.user.role === 'box-office') ?
                    <div
                        className={"showtix-category__content " + (this.props.isCategoryOpen[this.props.category.name] ? 'is-active' : '')}
                        id={`category-${this.props.category.name}`}
                    >
                        {/* 
                            <div className="row mt-2">
                                <div className="col-12 col-md-4 text-left">
                                    <div className="showtix-form__group">
                                        <label className="showtix-label" htmlFor={`limit-${this.props.category.name}`}>{strings.limit}</label>
                                        <div className="showtix-form__select">
                                            <select className="showtix-input"
                                                id={`limit-${this.props.category.name}`}
                                                value={this.props.limit[this.props.category.name]}
                                                onChange={(e) => this.props.handleSelectLimit(e, this.props.category.name)}
                                            >
                                                <option value="5">5</option>
                                                <option value="10">10</option>
                                                <option value="25">25</option>
                                                <option value="50">50</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-md-4 text-left">
                                    <div className="showtix-form__group">
                                        <label className="showtix-label" htmlFor={`page-${this.props.category.name}`}>{strings.page}</label>
                                        <div className="showtix-form__select">
                                            <select className="showtix-input"
                                                id={`page-${this.props.category.name}`}
                                                value={this.props.page[this.props.category.name]}
                                                onChange={(e) => this.props.handleSelectPage(e, this.props.category.name)}
                                            >
                                                {Array.from(Array(10).keys()).map((value) => (
                                                    <option value={value} key={`page-${value}`}>{value+1}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-md-4 text-left">
                                    <div className="showtix-form__group">
                                        <p><br /></p>
                                        <button
                                            className="showtix-button showtix-background__primary-3"
                                            onClick={() => this.props.updateCategoryEvents(this.props.category.name)}
                                        >
                                            {strings.refresh}
                                            <i></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <hr className="showtix-category__filter" />
                        */}
                        
                        {this.props.category.name === 'past' ? (
                            <InfiniteScroll
                                dataLength={this.props.events.filter((event) => event.status === this.props.category.name).length} //This is important field to render the next data
                                next={this.fetchData}
                                hasMore={true}
                                //loader={<h4>Loading...</h4>}
                                // below props only if you need pull down functionality
                                //refreshFunction={this.refresh}
                                //pullDownToRefresh
                                //pullDownToRefreshThreshold={50}
                                //pullDownToRefreshContent={
                                //    <h3 style={{ textAlign: 'center' }}>&#8595; Pull down to refresh</h3>
                                //}
                                //releaseToRefreshContent={
                                //    <h3 style={{ textAlign: 'center' }}>&#8593; Release to refresh</h3>
                                //}
                            >
                                <div className="row">
                                    {this.props.events.filter((event) => event.status === this.props.category.name).map((event, i) => {
                                        return (
                                            <React.Fragment key={"event_"+i}>
                                                <Event
                                                    client={this.props.client}
                                                    user={this.props.user}
                                                    is_client={this.props.is_client}
                                                    current_client_id = {this.props.current_client_id}
                                                    client_name={this.props.client_name}
                                                    event={event}
                                                    toggleAllCategories={this.props.toggleAllCategories}
                                                    toggleDetails={this.props.toggleDetails}
                                                    toggleDate={this.props.toggleDate}
                                                    toggleAllDates={this.props.toggleAllDates}
                                                    toggleDateSettings={this.props.toggleDateSettings}
                                                    closeAllOpenDateSettings={this.props.closeAllOpenDateSettings}
                                                    populateTicketSelection={this.props.populateTicketSelection}
                                                    toggleConfirmDeleteEvent={this.props.toggleConfirmDeleteEvent}
                                                    toggleConfirmEarlyPayout={this.props.toggleConfirmEarlyPayout}
                                                    handlePrinterChange={this.props.handlePrinterChange}
                                                    currentPrinter={this.props.currentPrinter}
                                                    printers={this.props.printers}
                                                    currentPrinterBoca={this.props.currentPrinterBoca}
                                                    printersBoca={this.props.printersBoca}
                                                    handlePrinterChangeBoca={this.props.handlePrinterChangeBoca}
                                                    getAccountEventReport={this.props.getAccountEventReport}
                                                    getStreamAccessReport={this.props.getStreamAccessReport}
                                                    getTicketPriceSummary={this.props.getTicketPriceSummary}
                                                    getTicketBreakdown={this.props.getTicketBreakdown}
                                                    getArtistCreditReport={this.props.getArtistCreditReport}
                                                    getQuestionTagReport={this.props.getQuestionTagReport}
                                                    getSeatingReport={this.props.getSeatingReport}
                                                    getVenueSeatLabel={this.props.getVenueSeatLabel}
                                                    getHouseCount={this.props.getHouseCount}
                                                    printWillCallTicketsDymo={this.props.printWillCallTicketsDymo}
                                                    printWillCallTickets={this.props.printWillCallTickets}
                                                    togglePassword={this.props.togglePassword}
                                                    setMessage={this.props.setMessage}
                                                    toggleWidgetModal={this.props.toggleWidgetModal}
                                                    isToggleWidgetModalOpen={this.props.isToggleWidgetModalOpen}
                                                    widgetModalEventID={this.props.widgetModalEventID}
                                                    category={this.props.category}
                                                    printersStar={this.props.printersStar}
                                                    printersStarUSB={this.props.printersStarUSB}
                                                    currentPrinterStar={this.props.currentPrinterStar}
                                                    handlePrinterChangeStar={this.props.handlePrinterChangeStar}
                                                />
                                            </React.Fragment>
                                        )}
                                    )}
                                    {this.props.flexpasses.filter((flexpass) => flexpass.status === this.props.category.name)
                                        .map((flexpass, i) => this.renderFlexpasses(flexpass, i, this.props.category.name))
                                    }
                                </div>
                            </InfiniteScroll>
                        ) : (
                            <div className="row">
                                {this.props.events.filter((event) => event.status === this.props.category.name).map((event, i) => {
                                    return (
                                        <React.Fragment key={"event_"+i}>
                                            <Event
                                                client={this.props.client}
                                                user={this.props.user}
                                                is_client={this.props.is_client}
                                                current_client_id = {this.props.current_client_id}
                                                client_name={this.props.client_name}
                                                event={event}
                                                toggleAllCategories={this.props.toggleAllCategories}
                                                toggleDetails={this.props.toggleDetails}
                                                toggleDate={this.props.toggleDate}
                                                toggleAllDates={this.props.toggleAllDates}
                                                toggleDateSettings={this.props.toggleDateSettings}
                                                closeAllOpenDateSettings={this.props.closeAllOpenDateSettings}
                                                populateTicketSelection={this.props.populateTicketSelection}
                                                toggleConfirmDeleteEvent={this.props.toggleConfirmDeleteEvent}
                                                toggleConfirmEarlyPayout={this.props.toggleConfirmEarlyPayout}
                                                handlePrinterChange={this.props.handlePrinterChange}
                                                currentPrinter={this.props.currentPrinter}
                                                printers={this.props.printers}
                                                currentPrinterBoca={this.props.currentPrinterBoca}
                                                printersBoca={this.props.printersBoca}
                                                handlePrinterChangeBoca={this.props.handlePrinterChangeBoca}
                                                getAccountEventReport={this.props.getAccountEventReport}
                                                getStreamAccessReport={this.props.getStreamAccessReport}
                                                getTicketPriceSummary={this.props.getTicketPriceSummary}
                                                getTicketBreakdown={this.props.getTicketBreakdown}
                                                getArtistCreditReport={this.props.getArtistCreditReport}
                                                getQuestionTagReport={this.props.getQuestionTagReport}
                                                getSeatingReport={this.props.getSeatingReport}
                                                getVenueSeatLabel={this.props.getVenueSeatLabel}
                                                getHouseCount={this.props.getHouseCount}
                                                printWillCallTicketsDymo={this.props.printWillCallTicketsDymo}
                                                printWillCallTickets={this.props.printWillCallTickets}
                                                togglePassword={this.props.togglePassword}
                                                setMessage={this.props.setMessage}
                                                toggleWidgetModal={this.props.toggleWidgetModal}
                                                isToggleWidgetModalOpen={this.props.isToggleWidgetModalOpen}
                                                widgetModalEventID={this.props.widgetModalEventID}
                                                category={this.props.category}
                                                printersStar={this.props.printersStar}
                                                printersStarUSB={this.props.printersStarUSB}
                                                currentPrinterStar={this.props.currentPrinterStar}
                                                handlePrinterChangeStar={this.props.handlePrinterChangeStar}
                                            />
                                        </React.Fragment>
                                    )}
                                )}
                                {this.props.flexpasses.filter((flexpass) => flexpass.status === this.props.category.name)
                                    .map((flexpass, i) => this.renderFlexpasses(flexpass, i, this.props.category.name))
                                }
                            </div>
                        )}
                        
                    </div>   
                :
                    <div
                        className={"showtix-category__content " + (this.props.isCategoryOpen[this.props.category.name] ? 'is-active' : '')}
                        id={`category-${this.props.category.name}`}
                    >
                        <div className="row">
                            {this.props.events.filter((event) => event.status === this.props.category.name).map((event, i) => {
                                return (
                                    <React.Fragment key={"event_"+i}>
                                        <Event
                                            user={this.props.user}
                                            is_client={this.props.is_client}
                                            current_client_id = {this.props.current_client_id}
                                            client_name={this.props.client_name}
                                            event={event}
                                            toggleAllCategories={this.props.toggleAllCategories}
                                            toggleDetails={this.props.toggleDetails}
                                            toggleDate={this.props.toggleDate}
                                            toggleAllDates={this.props.toggleAllDates}
                                            toggleDateSettings={this.props.toggleDateSettings}
                                            closeAllOpenDateSettings={this.props.closeAllOpenDateSettings}
                                            populateTicketSelection={this.props.populateTicketSelection}
                                            toggleConfirmDeleteEvent={this.props.toggleConfirmDeleteEvent}
                                            toggleConfirmEarlyPayout={this.props.toggleConfirmEarlyPayout}
                                            handlePrinterChange={this.props.handlePrinterChange}
                                            currentPrinter={this.props.currentPrinter}
                                            printers={this.props.printers}
                                            currentPrinterBoca={this.props.currentPrinterBoca}
                                            printersBoca={this.props.printersBoca}
                                            getAccountEventReport={this.props.getAccountEventReport}
                                            getStreamAccessReport={this.props.getStreamAccessReport}
                                            getTicketPriceSummary={this.props.getTicketPriceSummary}
                                            getTicketBreakdown={this.props.getTicketBreakdown}
                                            getArtistCreditReport={this.props.getArtistCreditReport}
                                            getQuestionTagReport={this.props.getQuestionTagReport}
                                            getSeatingReport={this.props.getSeatingReport}
                                            getVenueSeatLabel={this.props.getVenueSeatLabel}
                                            getHouseCount={this.props.getHouseCount}
                                            printWillCallTicketsDymo={this.props.printWillCallTicketsDymo}
                                            printWillCallTickets={this.props.printWillCallTickets}
                                            togglePassword={this.props.togglePassword}
                                            category={this.props.category}
                                            printersStar={this.props.printersStar}
                                            printersStarUSB={this.props.printersStarUSB}
                                            currentPrinterStar={this.props.currentPrinterStar}
                                            handlePrinterChangeStar={this.props.handlePrinterChangeStar}
                                        />
                                    </React.Fragment>
                                )}
                            )}

                            {this.props.flexpasses.filter((flexpass) => flexpass.status === this.props.category.name)
                                .map((flexpass, i) => this.renderFlexpasses(flexpass, i, this.props.category.name))
                            }

                        </div>    
                    </div>
                }   
            </div>   
        );
    }
}

EventCategory.propTypes = {
    events: PropTypes.array,
    is_client: PropTypes.bool,
    category: PropTypes.shape({
        name: PropTypes.string
    }),
    isCategoryOpen: PropTypes.shape({
        active: PropTypes.bool,
        pending: PropTypes.bool,
        past: PropTypes.bool,
    }),
    toggleCategory: PropTypes.func,
    toggleAllCategories: PropTypes.func,
    toggleDetails: PropTypes.func,
    toggleDate: PropTypes.func,
    toggleAllDates: PropTypes.func,
    toggleDateSettings: PropTypes.func,
    closeAllOpenDateSettings: PropTypes.func,
    populateTicketSelection: PropTypes.func,
    toggleConfirmDeleteEvent: PropTypes.func
}

export default EventCategory;


// WEBPACK FOOTER //
// ./src/components/EventListing/EventCategory/EventCategory.js